import { ActionType } from "../constants/marks";

import { showMarkApi } from "../../api/marks/marks";

export const showMarkAction = mark_id => dispatch => {
  return showMarkApi(mark_id)
    .then(
      dispatch({
        type: ActionType.SHOW_MARK_START
      })
    )
    .then(response => {
      dispatch({
        type: ActionType.SHOW_MARK_SUCCESS,
        payload: response.data.item
      });
    })
    .catch(error => {
      dispatch({
        type: ActionType.SHOW_MARK_ERROR,
        payload: error.response
      });
    });
};

export const openSidebarAction = () => dispatch => {
  return dispatch({
    type: ActionType.OPEN_SIDEBAR
  });
};

export const closeSidebarAction = () => dispatch => {
  return dispatch({
    type: ActionType.CLOSE_SIDEBAR
  })
}